import { Helmet } from 'react-helmet-async';

import { isProd } from './utils/config';

const GA_ID = 'G-91DCBBZQ0W';

export function GoogleAnalyticsHead() {
	if (!isProd) {
		return null;
	}

	return (
		<Helmet>
			<script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} />
			<script>
				{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
        `}
			</script>
		</Helmet>
	);
}

type GtagCommand = 'event' | 'config' | 'js' | 'set';
type GtagEventName = string;
type GtagEventParams = Record<string, unknown>;

export const GTag = (command: GtagCommand, eventName: GtagEventName, params?: GtagEventParams) => {
	if (isProd) {
		gtag(command, eventName, params);
	}
};
